import onReady from '../utils/onReady';
import queryStringParam from '../utils/queryStringParam';


/**
 * videoPlayer class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class videoPlayer {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.
        onReady(() => this.init(container));

        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }

    /**
     * Checks if querystring has autoplay
     *
     */
    checkAutoPlay() {
        if(window.location.href.indexOf("autoplay") > -1) {
            if (queryStringParam("autoplay") === this.videoNumber) {
                this.autoPlay = "?autoplay=1";
                this.scrollToVideo();
            }
        }
    }

    /**
     * Adds ID to videoelement, based on the videonumber
     *
     */
    addId() {
        this.videoNumber = this.videoSrc.match(/\d+/g)[0];
        this.dom.container.id = "video" + this.videoNumber;
    }

    // Since ID isn't available on page load, we instead set the hash value after ID has been added with JS.
    scrollToVideo() {
        window.location.hash = "#" + this.dom.container.id;
    }

    /**
     * Adds video to iframe
     *
     */
    addVideo() {
        this.addId();
        this.checkAutoPlay();
        this.dom.iFrame.src = "https://player.vimeo.com/video/" + this.videoNumber + this.autoPlay;
    }


    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        // Put your other DOM-specific initializations here, and get your class moving!

        this.dom.iFrame = this.dom.container.querySelector("iframe");
        this.videoSrc = this.dom.container.dataset.videoSrc;
        this.autoPlay = "";

        this.addVideo();
    }
}


export default videoPlayer;